import styled from 'styled-components';
import { FontFamily, HighlightColor } from '../../shared-styles';

export const StyledLabel = styled.span<{ color?: string; $noBg?: boolean }>`
  font-weight: 600;
  ${FontFamily}
  ${HighlightColor}
`;
